export function getQueryObject(queryString: string = window.location.search): {[p:string]: string} {
  const querySearchParams: URLSearchParams = new URLSearchParams(queryString)
  return Object.fromEntries(Array.from(querySearchParams.entries()))
}
